// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../Users/shinri/AppData/Roaming/npm/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ShogiPlayerGround .CommentBlock{line-height:1.5rem}.ShogiPlayerGround .CommentBlock .column{margin-top:var(--sp_common_gap)}", ""]);
// Exports
module.exports = exports;
